import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.function.name.js";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { Box, Pill, Typography, RaiseColors, makeStyles, Button, useMediaQuery, useTheme } from "client/componentLibrary";
import { TrackingEventContext, TrackingEventNames, TrackingEventPageView } from "utils/Analytics/TrackingConstants";
import { getTextWidth } from "client/utils/getTextWidth";
import { DealroomVoteStateEnum } from "utils/Enums";
import classnames from "classnames";
import { getMoreCategoriesPillWidth, MoreCategoriesPill } from "componentLibrary/MuiComponentWrappers/Button/Pill";
import { trackEvent } from "utils/Analytics";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      compareButton: {
        border: "1px solid ".concat(RaiseColors.bluePeeps),
        background: "white",
        marginRight: 18,
        height: 40,
        "&:hover $compareButtonText": {
          fontWeight: 700
        }
      },
      showMapButton: {
        border: "1px solid ".concat(RaiseColors.destructive500),
        background: "white",
        height: 40,
        "&:hover $showMapButtonText": {
          fontWeight: 700
        }
      },
      compareButtonIcon: {
        marginRight: 5,
        color: RaiseColors.bluePeeps
      },
      compareButtonText: {
        display: "inline-flex",
        flexDirection: "column"
      },
      showMapButtonText: {
        display: "inline-flex",
        flexDirection: "column",
        "&::after": {
          content: "attr(data-content)",
          fontWeight: 700,
          height: 0,
          overflow: "hidden",
          visibility: "hidden"
        }
      },
      icon: {
        marginRight: 4
      },
      grid: {
        display: "flex",
        alignItems: "center",
        flex: 1,
        marginRight: 18,
        "& > div": {
          padding: 4,
          "&:first-child": {
            paddingLeft: 0
          }
        }
      },
      categoryContainer: _defineProperty(_defineProperty(_defineProperty({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "sticky",
        top: 82,
        // accounts for topNavBar height, we don't need to account for mobile header because it is relatively positioned
        zIndex: 2,
        // Needs to be under topNav due to shadow but above all elements on listings page (set to 2 because some elements like marketStatus is at 1)
        paddingBottom: 16,
        backgroundColor: RaiseColors.white
      }, theme.breakpoints.up("sm"), {
        paddingRight: 28
      }), theme.breakpoints.up("tablet"), {
        paddingRight: 36
      }), theme.breakpoints.up("laptop"), {
        paddingRight: 48,
        top: 82 // accounts for topNav height
      })
    };
  });
};

/// Since a category could either be a DealroomVoteStateEnum or a Custom defined DealroomlistingCategory, we need to differentiate.
/// Type casting works for TS compiler, but when compiled to JS, types aren't recognized.
/// Only DealroomlistingCategory types will have an id, so for DealroomVoteStateValues, this function will return false.
/// Uses User-Defined Typeguards TS technique to check the category type.
/// https://www.typescriptlang.org/docs/handbook/advanced-types.html#type-guards-and-differentiating-types
export function isDealroomlistingCategory(category) {
  return (category === null || category === void 0 ? void 0 : category.id) !== undefined;
}
export function getCategoryPillWidth(label) {
  var buttonPadding = 32;
  var itemSpacing = 8;
  var offset = 4; // accounts for border and few px for rounding offsets

  return getTextWidth(label) + buttonPadding + itemSpacing + offset;
}
var ListingsCategoryBar = function ListingsCategoryBar(_ref) {
  var _document$getElementB, _document$getElementB2;
  var categories = _ref.categories,
    selectedCategory = _ref.selectedCategory,
    onCategoryChanged = _ref.onCategoryChanged,
    showMap = _ref.showMap,
    onShowMapClick = _ref.onShowMapClick,
    onCompareClick = _ref.onCompareClick,
    isListingsView = _ref.isListingsView;
  var classes = useStyles()();
  var theme = useTheme();
  var inTabletOrHigherView = useMediaQuery(theme.breakpoints.up("tablet"));

  /// Calculations to determine which category pills are shown or nested under More Categories Menu for responsive layouts
  var visibleCategories = [];
  var moreCategories = [];
  var totalGridWidth = (_document$getElementB = (_document$getElementB2 = document.getElementById("grid")) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.clientWidth) !== null && _document$getElementB !== void 0 ? _document$getElementB : 0;
  var totalPillsWidth = 0;
  _forEachInstanceProperty(categories).call(categories, function (category, index, array) {
    var _DealroomVoteStateEnu, _DealroomVoteStateEnu2;
    var label = isDealroomlistingCategory(category) ? category.name : (_DealroomVoteStateEnu = _valuesInstanceProperty(DealroomVoteStateEnum)[category]) === null || _DealroomVoteStateEnu === void 0 ? void 0 : _DealroomVoteStateEnu.label;
    var value = isDealroomlistingCategory(category) ? category.id : (_DealroomVoteStateEnu2 = _valuesInstanceProperty(DealroomVoteStateEnum)[category]) === null || _DealroomVoteStateEnu2 === void 0 ? void 0 : _DealroomVoteStateEnu2.value;
    var hidden = isDealroomlistingCategory(category) ? category.hidden : false;
    if (hidden) return;
    var categoryObj = {
      label: label,
      isSelected: value === selectedCategory,
      onClick: function onClick() {
        return onCategoryChanged(value);
      }
    };
    var nextPillWidth = getCategoryPillWidth(label);

    /// If pills are already overflowing, skip calculations and add the rest of More Categories Menu
    if (moreCategories.length > 0) {
      moreCategories.push(categoryObj);
      return;
    }

    // We need to check if this is the last element in array to make sure we leave room for More Categories Pill if needed
    if (index !== array.length - 1) {
      if (totalPillsWidth + nextPillWidth < totalGridWidth - getMoreCategoriesPillWidth()) {
        visibleCategories.push(categoryObj);
        totalPillsWidth += nextPillWidth;
      } else {
        moreCategories.push(categoryObj);
      }
    } else {
      if (totalPillsWidth + nextPillWidth <= totalGridWidth) {
        visibleCategories.push(categoryObj);
        totalPillsWidth += nextPillWidth;
      } else {
        moreCategories.push(categoryObj);
      }
    }
  });

  /* The selected category should always be visible outside the More Categories Menu
   * This checks whether the selected category exists inside the menu, and moves it outside and readjusts layout if necessary
   *
   * E.g. Selected Element = Category3
   * Initial Layout: <Category1> <Category2> <More Categories: Category3, Category4>
   * Desired Layout: <Category1> <Category3> <More Categories: Category2, Category4>
   */

  var selectedIndex = _findIndexInstanceProperty(moreCategories).call(moreCategories, function (category) {
    return category.isSelected;
  });
  if (selectedIndex !== -1 && visibleCategories.length > 0) {
    var selectedFromMore = moreCategories[selectedIndex];
    var selectedFromMoreWidth = getCategoryPillWidth(selectedFromMore.label);
    _spliceInstanceProperty(moreCategories).call(moreCategories, selectedIndex, 1);
    var lastVisibleElement = visibleCategories.pop();
    var lastVisibleElementWidth = getCategoryPillWidth(lastVisibleElement.label);
    moreCategories.unshift(lastVisibleElement);
    if (selectedFromMoreWidth > lastVisibleElementWidth && visibleCategories.length > 0) {
      // Pop two elements if the selected pill is bigger than the pill it is swapping with
      moreCategories.unshift(visibleCategories.pop());
    }
    visibleCategories.push(selectedFromMore);
  }
  var trackCategoryClick = function trackCategoryClick(categoryName) {
    if (isListingsView) {
      trackEvent(TrackingEventNames.ELEMENT_PRESSED, {
        pageView: TrackingEventPageView.CLIENT_DEALROOM_LISTINGS,
        context: TrackingEventContext.CATEGORY_PILL,
        category_name: categoryName
      });
    }
  };
  return /*#__PURE__*/_jsxs(Box, {
    className: classes.categoryContainer,
    children: [/*#__PURE__*/_jsxs("div", {
      className: classes.grid,
      id: "grid",
      children: [_mapInstanceProperty(visibleCategories).call(visibleCategories, function (category, index) {
        return /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Pill, {
            variant: "category",
            isSelected: category.isSelected,
            onClick: function onClick() {
              category.onClick();
              trackCategoryClick(category.label);
            },
            children: category.label
          })
        }, index);
      }), moreCategories.length > 0 && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(MoreCategoriesPill, {
          categories: moreCategories,
          trackCategoryClick: trackCategoryClick
        })
      })]
    }), inTabletOrHigherView && !showMap ? /*#__PURE__*/_jsxs(Button, {
      onClick: onCompareClick,
      className: classes.compareButton,
      variant: "secondaryButton",
      children: [/*#__PURE__*/_jsx("i", {
        className: classnames("far fa-balance-scale-left", classes.compareButtonIcon)
      }), /*#__PURE__*/_jsx(Typography, {
        className: classes.compareButtonText,
        color: RaiseColors.bluePeeps,
        weight: "semibold",
        children: "Compare"
      })]
    }) : null, /*#__PURE__*/_jsxs(Button, {
      onClick: onShowMapClick,
      className: classes.showMapButton,
      variant: "secondaryButton",
      children: [showMap ? /*#__PURE__*/_jsxs("span", {
        className: "fa-stack",
        children: [/*#__PURE__*/_jsx("i", {
          style: {
            color: RaiseColors.destructive500
          },
          className: "far fa-map"
        }), /*#__PURE__*/_jsx("i", {
          style: {
            color: RaiseColors.destructive500
          },
          className: "far fa-slash fa-stack-1x"
        })]
      }) : /*#__PURE__*/_jsx("i", {
        style: {
          marginRight: 5,
          color: RaiseColors.destructive500
        },
        className: "far fa-map"
      }), /*#__PURE__*/_jsx(Typography, {
        className: classes.showMapButtonText,
        color: RaiseColors.destructive500,
        weight: "semibold",
        "data-content": showMap ? "Hide Map" : "Show Map",
        children: showMap ? "Hide Map" : "Show Map"
      })]
    })]
  });
};
export default ListingsCategoryBar;